export const roles = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'ADMIN_DYNAMIC_TABLE', label: 'Admin Dynamic Table' },
  { value: 'PORTFOLIO', label: 'Portfolio Manager' },
]
